function ConfigController($scope, $timeout) {
    $scope.loaded = true;

    $scope.getContentHeight = function () {
        return $(window).height() - 68 - 20;
    };

    $scope.setRightPanelHeight = function () {
        var panelHeight = $scope.getContentHeight();
        var $rightPanel = $('.pane.right');

        if ($rightPanel.length > 0) {
            $rightPanel.height(panelHeight - 5);
            $rightPanel.find('.nano').height(panelHeight - $rightPanel.find('.heading').first().height() - 30);
        }
    };

    function addCurrent($event) {
        $($event.target.parentNode).children('.panel-heading').addClass('current');
        $($event.target.parentNode).addClass('current');
        $scope.updateRightScroll();
    }

    function removeCurrent($event) {
        $($event.target.parentNode).children('.panel-heading').removeClass('current');
        $($event.target.parentNode).removeClass('current');
        $scope.updateRightScroll();
    }

    function accordionHeadingClick($event) {
        $scope.$root.currentSubCategory = $event.currentTarget.text ? $event.currentTarget.text.trim() : null;
        $event.preventDefault();
    }

    function panelHeadingClick($event) {
        if ($($event.target.parentNode).hasClass('current')) {
            $($event.target.parentNode.parentNode).children('.collapse').collapse('hide');
        }
    }

    angular.element(document).ready(function () {
        $scope.configPageOptions = $scope.configPageOptions || {};
        if (!$scope.configPageOptions.noHeightCalcs) {
            $scope.setRightPanelHeight();
        }

        var $configPage = $($scope.configPageOptions.selector || '#configPage');

        $configPage.on('shown.bs.collapse', '.collapse', addCurrent);
        $configPage.on('hidden.bs.collapse', '.collapse', removeCurrent);
        $configPage.on('click', '.accordion-heading', accordionHeadingClick);
        $configPage.on('click', '.panel-heading', panelHeadingClick);

    });

    var windowResize = function () {
        if (!$scope.configPageOptions || !$scope.configPageOptions.noHeightCalcs) {
            $scope.tableConfig.height = $scope.getContentHeight();
            $scope.setRightPanelHeight();
            $scope.$root.updateScroll('#configPage .nano');
        }
    };

    $(window).resize(windowResize);

    $scope.$watch('$root.menuClosed', function (newValue, oldValue) {
        if (newValue !== oldValue) {
            windowResize();
        }
    });

    $scope.updateRightScroll = function () {
        if ($scope.loaded) {
            $scope.$root.updateScroll('.pane.right .nano');
        }
    };


    $scope.configDebugMode = function (selectedObjects, type, extend) {
        var selectedItems = [];
        selectedObjects.forEach(function (object) {
            selectedItems.push(object.id);
        });
        var sendData = { items: selectedItems, type: type };
        var typeName = (type === 'Site' ? 'site' : 'User');
        var action = (extend ? 'extend ' : 'disable') + ' debug mode';
        var len = selectedItems.length;
        if (len === 0) {
            $scope.$root.alert('Please select ' + typeName + 's to ' + action);
            return;
        }
        var itemsMessage = len === 1 ? 'this ' + typeName : len + ' ' + typeName + 's';
        itemsMessage = action + ' ' + itemsMessage;
        $scope.$root.confirm('Are you sure you want to ' + itemsMessage + '?', function () {
            store.save({
                path: 'debugMode',
                method: 'POST',
                data: sendData,
                dataObj: 'json',
                queryParams: { extend: extend },
                success: function (data) {
                    $scope.$root.handleServerResponse(data, '', typeName + 's ' + action + ' successfully');
                    if (data.status !== 'ERROR') {
                        selectedObjects.forEach(function (object) {
                            if (data.data.debugMode){
                                var debugMode = 0;
                                if(data.data.debugMode[object.id]) {
                                    debugMode = data.data.debugMode[object.id];
                                }
                                object.debugModeTimestamp = debugMode;
                                if ($scope.orig && $scope.orig.id && $scope.orig.id == object.id) {
                                    $scope.orig.debugModeTimestamp = debugMode;
                                }
                                if($scope.site && $scope.site.id && $scope.site.id == object.id){
                                    $scope.site.debugModeTimestamp = debugMode;
                                }
                            }
                        });
                    }
                }
            });
        });
    };

    $scope.$on('$destroy', function () {
        $scope.loaded = false;
        var $configPage = $(($scope.configPageOptions && $scope.configPageOptions.selector) || '#configPage');
        $configPage.off().find('*').off();
        $configPage.find('.nano').off().find('*').off();
        $configPage.find('.nano').nanoScroller({ destroy: true });

        $scope.$root.currentCategory = null;
        $scope.$root.currentSubCategory = null;

        $(window).off('resize', windowResize);
    });
}
